import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const LoyaltyPoint = ({ loyaltySymbol , points  })=>/*#__PURE__*/ React.createElement("div", {
        className: "loyalty-point"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "loyalty-point__value"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "payback-card",
        className: "loyalty-point__icon",
        width: 24,
        height: 24,
        "data-t": "payback-card-icon"
    }), /*#__PURE__*/ React.createElement("span", null, points, " ", loyaltySymbol)))
;

export { LoyaltyPoint };
//# sourceMappingURL=LoyaltyPoint.js.map
